import React, { useMemo, useState } from "react";
import {
  FiArrowLeft,
  FiCheck,
  FiCreditCard,
  FiInfo,
  FiShield,
} from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const formatAmount = (value) => {
  const numericValue = Number(String(value || "").replace(/[^\d.]/g, ""));

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return "23,800";
  }

  return numericValue.toLocaleString("en-IN");
};

const RepaymentPage = ({
  setScreen,
  loanAmount = "",
  setRepaymentData,
}) => {
  const totalAmount = useMemo(
    () => Number(String(loanAmount || "").replace(/[^\d.]/g, "")) || 23800,
    [loanAmount]
  );

  const [paymentType, setPaymentType] = useState("full");
  const [partialAmount, setPartialAmount] = useState("");

  const amountToPay =
    paymentType === "full"
      ? totalAmount
      : Number(partialAmount || 0);

  const isValidPartialPayment =
    paymentType === "partial" &&
    amountToPay > 0 &&
    amountToPay <= totalAmount;

  const canProceed =
    paymentType === "full" ||
    isValidPartialPayment;

  const handleProceed = () => {
    if (!canProceed) return;
      setRepaymentData({
    paymentType,
    amount: amountToPay,
    remainingAmount: totalAmount - amountToPay,
  });

      setScreen("/apply-new/demoPayment");
    console.log("Proceeding with payment:", {
      paymentType,
      amount: amountToPay,
    });
  };

  return (
    <section className="fw-screen fw-repayment fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      {/* Header */}
      <header className="fw-repayment__header">
        <button
          type="button"
          className="fw-repayment__back"
          onClick={() => setScreen("/apply-new/activeLoanHome")}
          aria-label="Go back"
        >
          <FiArrowLeft />
        </button>

        {/* <div className="fw-brand fw-brand--small">
          <span className="fw-brand__top">FUNDS</span>
          <span className="fw-brand__bottom">WALLE</span>
        </div> */}

        <div className="fw-repayment__header-spacer" />
      </header>

      {/* Page Intro */}
      <div className="fw-repayment__intro">
        <p className="fw-repayment__eyebrow">
          LOAN REPAYMENT
        </p>

        <h1>Make a Repayment</h1>

        <p>
          Choose how much you would like to repay towards
          your active loan.
        </p>
      </div>

      {/* Total Amount Card */}
      <div className="fw-repayment__summary">
        <div className="fw-repayment__summary-icon">
          <FiCreditCard />
        </div>

        <div>
          <span>Total Outstanding Amount</span>
          <strong>₹{formatAmount(totalAmount)}</strong>
        </div>
      </div>

      {/* Payment Options */}
      <div className="fw-repayment__options">
        <h2>Select Repayment Type</h2>

        {/* Full Payment */}
        <button
          type="button"
          className={`fw-repayment__option ${
            paymentType === "full" ? "is-selected" : ""
          }`}
          onClick={() => {
            setPaymentType("full");
            setPartialAmount("");
          }}
        >
          <span className="fw-repayment__radio">
            {paymentType === "full" && <FiCheck />}
          </span>

          <span className="fw-repayment__option-copy">
            <strong>Full Payment</strong>
            <small>
              Pay the complete outstanding amount
            </small>
          </span>

          <span className="fw-repayment__option-amount">
            ₹{formatAmount(totalAmount)}
          </span>
        </button>

        {/* Partial Payment */}
        <button
          type="button"
          className={`fw-repayment__option ${
            paymentType === "partial" ? "is-selected" : ""
          }`}
          onClick={() => setPaymentType("partial")}
        >
          <span className="fw-repayment__radio">
            {paymentType === "partial" && <FiCheck />}
          </span>

          <span className="fw-repayment__option-copy">
            <strong>Part Payment</strong>
            <small>
              Pay any amount towards your loan
            </small>
          </span>
        </button>
      </div>

      {/* Partial Amount Input */}
      {paymentType === "partial" && (
        <div className="fw-repayment__partial">
          <label htmlFor="partialRepayment">
            Enter repayment amount
          </label>

          <div className="fw-repayment__input-wrap">
            <span>₹</span>

            <input
              id="partialRepayment"
              type="text"
              inputMode="numeric"
              value={partialAmount}
              placeholder="Enter amount"
              onChange={(event) => {
                const value = event.target.value
                  .replace(/\D/g, "")
                  .slice(0, 7);

                setPartialAmount(value);
              }}
            />
          </div>

          {partialAmount &&
            Number(partialAmount) > totalAmount && (
              <p className="fw-repayment__error">
                Amount cannot be greater than your
                outstanding loan amount.
              </p>
            )}

          {partialAmount &&
            Number(partialAmount) === 0 && (
              <p className="fw-repayment__error">
                Enter a valid repayment amount.
              </p>
            )}

          <p className="fw-repayment__hint">
            Maximum payment: ₹{formatAmount(totalAmount)}
          </p>
        </div>
      )}

      {/* Payment Amount */}
      {/* <div className="fw-repayment__pay-card">
        <span>Amount to Pay</span>

        <strong>
          ₹{formatAmount(amountToPay)}
        </strong>
      </div> */}
<div className="fw-repayment__pay-card">
  <span>Amount to Pay</span>

  <strong>
    {paymentType === "partial"
      ? partialAmount
        ? `₹${Number(partialAmount).toLocaleString("en-IN")}`
        : "₹0"
      : `₹${formatAmount(totalAmount)}`}
  </strong>
</div>
      {/* Security */}
      <div className="fw-repayment__secure">
        <div className="fw-repayment__secure-icon">
          <FiShield />
        </div>

        <div>
          <strong>Safe & Secure Payment</strong>
          <p>
            Your payment will be processed through a
            secure payment gateway.
          </p>
        </div>
      </div>

      {/* Info */}
      <div className="fw-repayment__info">
        <FiInfo />

        <p>
          Once the payment is completed, your repayment
          status will be updated automatically.
        </p>
      </div>

      {/* CTA */}
      <div className="fw-repayment__footer">
        <button
          type="button"
          className="fw-btn fw-btn--primary fw-repayment__cta"
          disabled={!canProceed}
          onClick={handleProceed}
        >
          Proceed to Pay
          <span>
            ₹{formatAmount(amountToPay)}
          </span>
        </button>

        <p className="fw-repayment__powered">
          Powered by Razorpay
        </p>
      </div>
    </section>
  );
};

export default RepaymentPage;